import React, { Component } from "react";
import {HorizontalLoader, modal, ModalActions} from "@mc/mc-legacy";
import { FormErrors, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { Button, Col, Row } from "reactstrap";
import { formatJmenoPrijmeni } from "../registration/commons";
import RegistrationContent from "../registration/RegistrationContent";
import RegistraceApi from "../../api/gen/core/RegistraceApi";
import { formatDate, FormActions, Form, FormBody } from "@mc/mc-legacy";
import UserAgreementFormSection from "./UserAgreementFormSection";
import * as TypAutentizace from "mc/lib/api/gen/ucty/v1/TypAutentizace";
import PropTypes from "prop-types";
import { withLang } from "../../i18n/withLang";
import { i18n } from "../../i18n/i18n";
import GetKontaktForm from "../profile/GetKontaktForm";
import {TypNotifikace} from "../../pages/ProfilePage";
import OverKontaktForm from "../profile/OverKontaktForm";

type FormData = {
  agreement: boolean;
  cisloDokladu: string;
};

const validate = (formData: FormData, props: { lang: string }) => {
  const errors: FormErrors<FormData> = {};

  if (!formData.agreement) {
    errors.agreement = i18n(props.lang, "Form_agreement_required");
  }

  if (!formData.cisloDokladu) {
    errors.cisloDokladu = i18n(props.lang, "ProcessLoginForm_cisloDokladu_required");
  }

  return errors;
};

class ProcessLoginForm extends Component<any> {
  static formName = "ProcessLoginForm";
  static propTypes = {
    userRegInfo: PropTypes.object,
    setOverenyEmail: PropTypes.func,
  };

    constructor(props) {
        super(props);
        this.state = {
            overenyEmail: null,
            overeniRequired: false
        };
        RegistraceApi.getEmailConfig().then((res) => {
            this.setState({
                overeniRequired: res,
            });
        });
    }

  renderIconZpusobRegistrace() {
    const { zpusobRegistrace } = this.props.userRegInfo;
    let icon = "government-buildings";

    if (zpusobRegistrace !== TypAutentizace.MOJE_ID) {
      icon = zpusobRegistrace;
    }

    return icon;
  }

    showOvereni = (typ, kontakt, userId, finishedCallback) => {
        const {onChange, dispatch} = this.props;

        dispatch(
            ModalActions.show(OverKontaktForm, {
                typ,
                kontakt,
                userId,
                onSubmit: (data) => {
                },
                onSubmitSuccess: () => {
                    dispatch(modal.ModalActions.hide());
                    finishedCallback();
                }
            }, "", {
                size: "lg",
                noHeader: true
            })
        );
    }

  render() {
    const { submitting, handleSubmit, userRegInfo, setOverenyEmail, dispatch } = this.props;
    const { overenyEmail, overeniRequired } = this.state;

    let title = '';
    let cursor = '';
    if (overeniRequired && !overenyEmail) {
        title = i18n(this.props.lang, "ProcessLoginForm_finish_disabled")
        cursor = 'not-allowed';
    }


      return (
      <Form onSubmit={handleSubmit} horizontal>
        <FormBody>
          <RegistrationContent icon={this.renderIconZpusobRegistrace()}>
            <Row>
              <Col>
                <p className={"mb-0 pl-3"}>
                  {formatJmenoPrijmeni(userRegInfo, this.props.lang)}
                  <br />
                  {formatDate(userRegInfo.datumNarozeni)}
                </p>
              </Col>
            </Row>
          </RegistrationContent>
            <div className={"pl-3"}>
                <UserAgreementFormSection submitting={submitting}/>
            </div>
            {overeniRequired && <GetKontaktForm
                registration
                typ={TypNotifikace.EMAIL}
                initialValues={{kontakt: userRegInfo.email}}
                onSubmit={(data) => {
                    return data
                }}
                onSubmitSuccess={(data) => {
                    this.showOvereni(TypNotifikace.EMAIL, data.kontakt, userRegInfo.uuid, () => {
                        this.setState({overenyEmail: data.kontakt});
                        setOverenyEmail(data.kontakt);
                        dispatch(modal.ModalActions.hide());
                    })
                }}
            />}
        </FormBody>
        <FormActions submitButton={false}>
          <Button className={"py-15"} id={"at-finish-reg"} color={"primary"} disabled={submitting || (overeniRequired && !overenyEmail)} title={title} style={{cursor: cursor}} >
            {i18n(this.props.lang, "ProcessLoginForm_button_dokoncitPrihlaseni")}
          </Button>
        </FormActions>
      </Form>
    );
  }
}

const reduxFormObj = reduxForm<FormData, any>({
  form: ProcessLoginForm.formName,
  validate,
})(ProcessLoginForm);
export default withLang(connect()(reduxFormObj));
